export default "__VITE_ASSET__Xo8p2h$M__"